import { BOUNDLESS_COBRAND_RELATIONSHIP_CODES } from '../WalletSavedCardsSection.constants';

export type CobrandPartnerEntry = {
  partner?: {
    code?: string;
  };
};

/**
 * WEB-212678: Boundless banner visibility is driven by cobrand program-partner codes
 * from phoenixAccountGetMemberStatusDetails (programPartners.coBrands), not saved
 * wallet payment methods.
 */
export const hasBoundlessCobrandRelationship = (coBrands?: CobrandPartnerEntry[]): boolean => {
  if (!coBrands?.length) {
    return false;
  }

  return coBrands.some(entry => {
    const code = entry.partner?.code?.toUpperCase();
    return code ? BOUNDLESS_COBRAND_RELATIONSHIP_CODES.includes(code) : false;
  });
};
